var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99869 0C9.54505 0 11.6155 1.95353 11.6155 4.35399C11.6155 6.75445 9.54505 8.70798 6.99869 8.70798H6.9714C5.73864 8.70417 4.58368 8.24866 3.71872 7.42532C2.85175 6.60293 2.37784 5.51086 2.38285 4.35113C2.38285 1.95353 4.45333 0 6.99869 0ZM6.99869 1.42941C5.28898 1.42941 3.89856 2.74161 3.89856 4.35399C3.89555 5.1354 4.21284 5.86631 4.79386 6.41806C5.37487 6.96981 6.14889 7.27571 6.97342 7.27857L6.99869 7.99327V7.27857C8.70839 7.27857 10.0998 5.96732 10.0998 4.35399C10.0998 2.74161 8.70839 1.42941 6.99869 1.42941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.398 6L19.1939 7.15637M14.6123 11.5564L17.0867 9.18002M17.0867 9.18002L18.8928 10.9146L21 8.89092L19.1939 7.15637M17.0867 9.18002L19.1939 7.15637M14.6123 11.5564C14.9231 11.8509 15.1702 12.2016 15.3394 12.5883C15.5085 12.975 15.5964 13.3899 15.5978 13.8093C15.5993 14.2287 15.5144 14.6443 15.3479 15.032C15.1815 15.4197 14.9368 15.772 14.628 16.0686C14.3192 16.3652 13.9524 16.6001 13.5486 16.76C13.1449 16.9198 12.7122 17.0014 12.2755 17C11.8388 16.9986 11.4067 16.9142 11.004 16.7518C10.6014 16.5893 10.2362 16.352 9.92951 16.0535C9.32634 15.4537 8.99258 14.6504 9.00013 13.8167C9.00767 12.9829 9.35591 12.1853 9.96985 11.5957C10.5838 11.0061 11.4143 10.6716 12.2825 10.6644C13.1507 10.6571 13.9871 10.9777 14.6117 11.5569L14.6123 11.5564Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C5.66667 11 1 11 1 13C1 15 5 15.5 7 15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnersIcon);
export default __webpack_public_path__ + "static/media/OwnersIcon.a4b1a583e4ae1e148e82a908bc27afa5.svg";
export { ForwardRef as ReactComponent };